import {AfterViewInit, Component, ElementRef, EventEmitter, Output, ViewChild} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {AuthProviderEnum} from "../enum/auth-provider-enum";

@Component({
  selector: 'fb-auth-email-method',
  templateUrl: './auth-email-method.component.html',
  styleUrls: ['./auth-email-method.component.scss']
})
export class AuthEmailMethodComponent implements  AfterViewInit {

	@ViewChild("authEmail")
	private emailInput: ElementRef<HTMLInputElement> = {} as ElementRef<HTMLInputElement>;

	protected readonly AuthProviderEnum = AuthProviderEnum;

	@Output()
	public authProvider: EventEmitter<AuthProviderEnum> = new EventEmitter<AuthProviderEnum>();

	@Output()
	public email: EventEmitter<FormControl> = new EventEmitter<FormControl>();

	ngAfterViewInit() {
		this.emailInput.nativeElement.focus();
	}

	public emailFormControl: FormControl = new FormControl('', [
		Validators.required,
		Validators.email
	]);

	public passwordFormControl: FormControl = new FormControl('', [
		Validators.required,
		Validators.minLength(8),
		Validators.maxLength(38)
	]);

	public authFormGroup: FormGroup = new FormGroup({
		username: this.emailFormControl,
		// password: this.passwordFormControl
	});

	public verifyEmail(): void {
		if (this.emailFormControl.valid) {
			this.email.emit(this.emailFormControl);
		}
		else {
			this.emailFormControl.markAsDirty();
		}

	}

}
